<template>
  <v-container fluid>
    <v-row>
      <v-col
        v-for="rs in data"
        :key="rs.id_restaurant"
        cols="12"
        sm="6"
        md="6"
      >
        <template>
          <v-card
            dark
            :loading="loading"
            class="mx-auto my-12 secondary"
          >
            <template slot="progress">
              <v-progress-linear
                color="deep-purple"
                height="10"
                indeterminate
              ></v-progress-linear>
            </template>

            <v-card-title class="font-weight-bold">
              Entrance {{ rs.entrance_name }}
            </v-card-title>

            <v-card-text>
              <v-row
                align="center"
                class="mx-0"
              >
              </v-row>

              <div class="my-4 text-subtitle-1">
                Status Payment : <v-chip :color="getColor(rs.status_payment)">
                  {{ rs.status_payment }}
                </v-chip><br>
                <span>
                  Date Payment :  {{ rs.date_payment }} <br>
                  Note Payment :  {{ rs.ket_payment }}
                </span>
              </div>

              <div>{{ rs.note }}</div>
            </v-card-text>

            <v-divider class="mx-4"></v-divider>

            <v-card-text>
              <v-expansion-panels
                multiple
              >
                <v-expansion-panel>
                  <v-expansion-panel-header>Entrance Selected</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row justify="center">
                      <v-expansion-panels popout>
                        <v-expansion-panel
                          v-for="(dt, index) in rs.date"
                          :key="index"
                        >
                          <v-expansion-panel-header>  {{ dt.date }} <span class="ml-auto"></span> {{ dt.jumlah }} Entrance Selected</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-simple-table>
                              <thead>
                                <tr>
                                  <th width="150">
                                    Name Entrance
                                  </th>
                                  <th width="100">
                                    Qty
                                  </th>
                                  <th width="100">
                                    Total
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="( dt1, index1) in dt.detail"
                                  :key="index1"
                                >
                                  <td>{{ dt1.description }}</td>
                                  <td> {{ Number(dt1.qty).toLocaleString() }}</td>
                                  <td>Rp. {{ Number(dt1.total).toLocaleString() }}</td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>

            <v-card-actions>
              <v-btn
              v-if="$store.state.user.level_user === 'Accounting' || $store.state.user.level_user === 'Admin' "
                 color="success"
                block
                class="text-capitalize"
                @click="ChangeStatusPayment(rs)"
              >
                Change Status Payment
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialogPayment"
      scrollable
      max-width="500px"
    >
      <v-card>
        <v-card-title>Select Status Payment</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-select
            v-model="payment.status_payment"
            dense
            outlined
            :items="['Waiting For Payment','Paid','Canceled']"
          />
          <v-menu
            v-if="payment.status_payment == 'Paid'"
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="payment.date_payment"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-if="payment.status_payment == 'Paid'"
                v-model="payment.date_payment"
                label="Date Payment"
                readonly
                dense
                outlined
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="payment.date_payment"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu.save(payment.date_payment)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
          <v-textarea
            v-if="payment.status_payment == 'Paid'"
            v-model="payment.ket_payment"
            dense
            outlined
            label="Keterangan Payment"
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            class="ml-auto"
            color="primary"
            @click="SaveStatusPayment()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import axios from 'axios'
import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
  mdiCalendar,
} from '@mdi/js'

export default {
  props: ['datacost'],
  data() {
    return {
      loading: false,
      selection: 1,
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
        mdiCalendar,
      },
      data: [],
      menu: false,
      dialogPayment: false,
      payment: {
        date_payment: '',
      },

    }
  },

  created() {
    this.initialize()
  },
  methods: {
    SaveStatusPayment() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/SaveStatusPayment', this.payment).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.data = response.data.data
        this.initialize()
        this.dialogPayment = false
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    ChangeStatusPayment(item) {
      this.payment = item
      this.dialogPayment = true
    },
    getColor(status) {
      if (status === 'Waiting For Payment') {
        return 'success'
      }
      if (status === 'Canceled') {
        return 'error'
      }

      return 'primary'
    },
    RemoveBintang(number) {
      number.replace('*', '')
      // eslint-disable-next-line radix
      const a = parseInt(number)

      return a
    },
    reserve() {
      this.loading = true
    },
    CountCostTravel() {
      this.travelcost.grandtotaltravelcost = 0
      this.travelcost.grandtotaltravelcostperpax = 0
      let grandtotal = 0
      let grandtotalperpax = 0
      this.travelcost.variablecost.forEach(number => {
      // eslint-disable-next-line no-const-assign
        grandtotal += number.total
        grandtotalperpax += number.per_pax
      })
      // eslint-disable-next-line radix
      this.travelcost.grandtotaltravelcost = parseInt(grandtotal) + parseInt(this.travelcost.record_guide.total)
      // eslint-disable-next-line radix
      this.travelcost.grandtotaltravelcostperpax = parseInt(grandtotalperpax) + parseInt(this.travelcost.record_guide.per_pax)
      this.$root.$emit('MakeInvoice', this.travelcost, 'travelcost')
    },
    initialize() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/getDataItinerari', { data: this.datacost, type: 'Entrance' }).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.data = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}

</script>
